import React from 'react';

type Props = {
    size?: {
        width: number;
        height: number;
    };
};

export const PatchIcon = ({size = {width: 32, height: 40}}: Props) => {
    return (
        <svg width={size.width} height={size.height} viewBox='0 0 32 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M1.59518 10.3571L10.4929 1.57645C10.8672 1.20709 11.3718 1 11.8977 1H28C29.6569 1 31 2.34315 31 4V36C31 37.6569 29.6569 39 28 39H4C2.34315 39 1 37.6569 1 36V11.7806C1 11.2456 1.21437 10.7329 1.59518 10.3571Z'
                stroke='#338AFF'
                strokeWidth='2'
            />
            <path d='M11 2V11C11 11.5523 10.5523 12 10 12H2' stroke='#338AFF' strokeWidth='2' />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M19 17.8284L23.2426 22.0711L20.4142 24.8995L16.1716 20.6569L19 17.8284ZM11.9289 24.8995L9.10051 27.7279L13.3431 31.9706L16.1716 29.1421L11.9289 24.8995ZM17.5858 16.4142C18.3668 15.6332 19.6332 15.6332 20.4142 16.4142L24.6569 20.6569C25.4379 21.4379 25.4379 22.7042 24.6569 23.4853L14.7574 33.3848C13.9763 34.1658 12.71 34.1658 11.9289 33.3848L7.68629 29.1421C6.90524 28.3611 6.90524 27.0948 7.68629 26.3137L17.5858 16.4142ZM15.2877 23.6621C15.6782 24.0526 16.3114 24.0526 16.7019 23.6621C17.0924 23.2715 17.0924 22.6384 16.7019 22.2478C16.3114 21.8573 15.6782 21.8573 15.2877 22.2478C14.8972 22.6384 14.8972 23.2715 15.2877 23.6621ZM14.9341 25.4298C14.5436 25.8203 13.9104 25.8203 13.5199 25.4298C13.1294 25.0393 13.1294 24.4061 13.5199 24.0156C13.9104 23.6251 14.5436 23.6251 14.9341 24.0156C15.3247 24.4061 15.3247 25.0393 14.9341 25.4298ZM17.409 25.7834C17.7995 26.1739 18.4327 26.1739 18.8232 25.7834C19.2137 25.3929 19.2137 24.7597 18.8232 24.3692C18.4327 23.9786 17.7995 23.9786 17.409 24.3692C17.0185 24.7597 17.0185 25.3929 17.409 25.7834ZM17.0555 27.5511C16.6649 27.9417 16.0318 27.9417 15.6412 27.5511C15.2507 27.1606 15.2507 26.5275 15.6412 26.1369C16.0318 25.7464 16.6649 25.7464 17.0555 26.1369C17.446 26.5275 17.446 27.1606 17.0555 27.5511Z'
                fill='#338AFF'
            />
        </svg>
    );
};
